

class BaseError {
  constructor() {
    Error.apply(this);
  }
}



export class ServiceError extends BaseError {

  // eslint-disable-next-line @typescript-eslint/no-parameter-properties
  constructor(public status: number, public response: ApiError) {
    super();
  }
}

/**
 * type guard for ApiError in exceptions
 */
 export function isServiceError(error: unknown): error is ServiceError {
  return (error as ServiceError).status !== undefined && (error as ServiceError).response !== undefined;
}

/**
 * 
 */
export interface ApiError {
  status: number;
  message: string;
  details?: string;
}

